import axios from "axios";
import {openProductPopupHandler} from "./productPopup";

const updateCartItemsCount = async () => {
    let {status, data} = await axios.get(`${window.Shopify.routes.root}cart.js`);

    if(status === 200) {
        const cartItemsCountElements = [...document.querySelectorAll('.js-cart-items-count')];

        cartItemsCountElements.map(cartItemsCount => cartItemsCount.setAttribute('data-count', data.items.length));
    }
}

export const normalizeQuantity = (input) => {
    let quantity = +input.value;
    const min = +input.getAttribute('min') || 1;
    const step = +input.getAttribute('step') || 1;

    if(quantity < min) {
        quantity = min;
    }

    if(quantity > min && step > 1) {
        const remainder = (quantity - min) % step;

        if(remainder !== 0) {
            quantity = min + (Math.floor((quantity - min) / step) * step);
        }
    }

    if(quantity !== +input.value) {
        input.value = quantity;
    }

    return quantity;
};

export const addToCartHandler = async (e, customQuantity = null) => {
    e.preventDefault();

    const form = e.currentTarget;
    const quantityInput = form.querySelector('.js-quantity-input[name="quantity"]');

    if(quantityInput && !customQuantity) {
        normalizeQuantity(quantityInput);
    }

    form.setAttribute('data-state', 'loading');

    const formData = new FormData(form);

    if(customQuantity) {
        formData.set('quantity', customQuantity);
    }

    try {
        let {status} = await axios.post(`${form.action}.js`, formData);

        if(status === 200) {
            await updateCartItemsCount();

            form.setAttribute('data-state', 'done');

            if(form.hasAttribute('data-popup')) {
                openProductPopupHandler('product-cart');
            }
        }
    } catch (e) {
        // TODO: Error message?
    }
}
